import React from 'react';
import '../scss/GitHubLink.scss';

const GitHubLink = () => (
    <div className="github-link">
        <a className="icon" href="https://github.com/ajrussellaudio/rhythmetic">
            <i className="fab fa-github fa-lg"></i>
        </a>
    </div>
);

export default GitHubLink;
